<script setup>
  //
// definePageMeta({
//   middleware: 'auth'
// })
const config = useRuntimeConfig()
const url = config.public.apiBase + '/shop?include=media';
const { data, status, error } = await useLazyFetch(url);

// data:   The result payload
// status: 'idle', 'pending', 'success', or 'error'
// error:  The error object if the fetch failed
// refresh: A function to re-fetch the data
const shops = computed(() => data.value?.data || [])
</script>

<template>
  <div class="px-4 max-w-7xl mx-auto my-4">
    <div v-if="status === 'pending'">
      <NavLoading />
    </div>

    <div v-else-if="error" class="alert alert-error">
      Failed to load shops: {{ error.message }}
    </div>

    <div v-else>
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
        <ShopCard 
          v-for="shop in shops"
          :id="shop.id"
          :key="shop.id"
          :type="shop.shop_type"
          :name="shop.name"
          :address="shop.address"
          :banner-url="shop.banner?.[0]?.original_url"
          :open-time="shop.opening_time"
          :close-time="shop.closing_time"
        />
      </div>
    </div>
  </div>
</template>
<style scoped></style>